import get from 'lodash/get';
import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../../utils/redux';

export const consts = createReqConsts('dashboard', 'appointment-locations-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dashboard',
  type: 'get',
  slug: [
    'locations',
    {
      type: 'payload.query',
      queryParameter: 'creatable_on_dashboard',
      selector: 'creatableOnDashboard',
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.SUCCEED: {
      return {
        ...state,
        sending: false,
        succeed: true,
        locations: payload,
      };
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/requests/appointment-locations-req.js